/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $IdName = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
};